/**
 * Resolve numeric user id from JWT profile (rest_framework_jwt payloads vary).
 */
export function resolveTimerUserId(profile) {
  if (!profile || typeof profile !== "object") return null;
  const candidates = [profile.user_id, profile.userId, profile.id, profile.pk];
  for (const raw of candidates) {
    if (raw == null || raw === "") continue;
    const n = Number(raw);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

/** Prefer the log row's owner; fall back to JWT actor. */
export function resolveTimerLogUserId(legacyRow, profile) {
  if (legacyRow && legacyRow.user_id != null && legacyRow.user_id !== "") {
    const n = Number(legacyRow.user_id);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return resolveTimerUserId(profile);
}
